import React from "react"
import Shimmer from "react-shimmer-effect"

const LoadingComponent = (props) => {
    return (
        <Shimmer>
        <div style={{ width: "30%", height: 15 }}></div>
      </Shimmer>
    )
}

export default LoadingComponent